import { render, staticRenderFns } from "./MapCarParts.vue?vue&type=template&id=6f5746e4&scoped=true"
import script from "./MapCarParts.vue?vue&type=script&lang=ts"
export * from "./MapCarParts.vue?vue&type=script&lang=ts"
import style0 from "./MapCarParts.vue?vue&type=style&index=0&id=6f5746e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5746e4",
  null
  
)

export default component.exports